<script>
import checkoutMixin from '@/v-shop/checkout/checkout-mixin'
export default {
	mixins: [checkoutMixin],
	data() {
		return { btnStatus: 'default', redirecting: false }
	},
	methods: {
		async submit() {
			if ((await this.checkout.beforeConfirm()) === false) return
			this.btnStatus = 'loading'
			let response = await this.checkout.stepSubmit()
			const orderId = response.data?.stepResponse?.orderId
			if (orderId) {
				this.redirectAfterPurchase(response.data?.stepResponse)
				this.redirecting = true
			} else {
				this.btnStatus = 'error'
			}
		},
	},
}
</script>
<template>
	<div>
		<div>
			<b> Confirma tu compra para recibir las instrucciones de pago. </b>
		</div>
		<div class="d-flex justify-center justify-sm-end pt-6">
			<IndeterminateProgressBtn
				v-model="btnStatus"
				default-color="cta"
				success-color="success"
				error-color="error"
				@click="submit()"
				:error-duration="5000"
				block
				x-large
			>
				Confirmar Compra
				<template #loading>
					{{ redirecting ? 'Ya casi terminamos...' : 'Confirmando tu compra...' }}
				</template>
				<template #success>
					<div></div>
				</template>
				<template #error>
					<v-icon left> mdi-close-thick </v-icon>
					Lo sentimos, ha ocurrido un error
				</template>
			</IndeterminateProgressBtn>
		</div>
	</div>
</template>

<style></style>

